import { Button } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @description Renders a clean button component.
 *
 * @author Maria Eduarda Franke
 * @param {React.ElementType} props.Icon - The icon component to be displayed before the button label.
 * @param {string} props.label - The label text for the button.
 * @param {boolean} props.loading - Determines if the button is in a loading state.
 * @param {function} props.onClick - The function to be called when the button is clicked.
 * @returns {ReactElement} The rendered primary button component.
 */
const CleanButton = ({ Icon, label, loading, onClick, ...props }) => {
    return (
        <Button
            startIcon={Icon && <Icon />}
            variant='outlined'
            color='primary'
            onClick={onClick}
            disabled={loading}
            sx={{
                fontWeight: 'bold'
            }}
            {...props}
        >
            {label}
        </Button>
    )
}

CleanButton.propTypes = {
    Icon: PropTypes.object,
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func
}

export default CleanButton
